module.exports = __webpack_public_path__ + "img/cronologic_logo_2020.e42c9234.png";